import $ from "jquery";

$(() => {
  $("table").each((idx, table) => {
    if ($(table).find("tr:first-child").find("th,td").length === 2) {
      $(table).css("table-layout", "fixed");
    }
  });
});
